export default "__VITE_ASSET__ub9chyRX__"